import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { when } from 'mobx'
import { observer, inject } from 'mobx-react'

@inject(['auth'])
@observer
class Login extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  state = {
    error: false,
    processing: false
  }

  componentWillMount() {
    const { location: { state } } = this.props

    this.authWatcher = when(
      () => this.props.auth.loggedIn,
      () => this.context.router.push(state && state.return_to || { pathname: '/' })
    )
  }

  componentWillUnmount() {
    this.authWatcher()
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.setState({ error: false, processing: true })

    const email    = this.refs.email.value
    const password = this.refs.password.value

    this.props.auth.login(email, password)
      .catch(() => { this.setState({ error: true, processing: false }) } )
  }

  render() {
    let errorMessage = this.state.error && <div className="error">Incorrect email or password. Please try again.</div>

    return (
      <div className="container auth">
        <div className="dialog login">
          <h3>Showcase IDX</h3>
          <form onSubmit={this.handleSubmit}>
            {errorMessage}
            <div className="form-section">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" title="Email" ref="email" required />
            </div>
            <div className="form-section">
              <label htmlFor="password">Password</label>
              <input type="password" id="password" title="Password" ref="password" required />
            </div>
            <button type="submit" disabled={this.state.processing}>
              Log In
              <div className="bounceloader">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
              </div>
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// client/components/Login.js